export enum EPortfolioManagementTabs {
  PERFORMANCE = 'performance',
  HEDGE = 'hedge',
  EVENTS = 'events',
  MISC = 'misc',
  ORDERS = 'orders'
}
